/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Modifications_TitleInputs */

const es_tyc_modifications_title = /** @type {(inputs: Tyc_Modifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Modificaciones a estos Terminos`)
};

const en_tyc_modifications_title = /** @type {(inputs: Tyc_Modifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Modifications to These Terms`)
};

/**
* | output |
* | --- |
* | "9. Modifications to These Terms" |
*
* @param {Tyc_Modifications_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_modifications_title = /** @type {((inputs?: Tyc_Modifications_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Modifications_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_modifications_title(inputs)
	return en_tyc_modifications_title(inputs)
});
export { tyc_modifications_title as "tyc.modifications.title" }